export default "__VITE_ASSET__DJ$15S8g__"